import { Article } from './Article';

export enum UserArticleProgressState {
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
}

export enum UserArticleQuizStage {
  GUIDING = 'guiding',
  ASSESSMENT = 'assessment',
  REPORT = 'report',
}

export type UserArticle = {
  article: Article;
  state: UserArticleProgressState;
  accuracy: number;
  createdAt: Date;
  updatedAt: Date;
  questionsCompleted: number;
  createdByMe?: boolean;
};
